import { GlButton, GlLoadingIcon } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
export default {
    name: 'WorkItemChildrenLoadMore',
    components: {
        GlButton,
        GlLoadingIcon
    },
    props: {
        fetchNextPageInProgress: {
            type: Boolean,
            required: true
        }
    },
    emits: [
        'fetch-next-page'
    ]
};
